import React from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Block from "components/Template/Block"
import classnames from "classnames"

const TwoColumnLowerThird = ({ children, classes, blocks }) => (
  <div className={classes.template}>
    {blocks.map(block => {
      return (
        <div key={block.id} className={classes[block.id]}>
          <div
            className={classnames({
              [classes.blockContainer]: block.name,
              [classes.blockContainerEmpty]: !block.name
            })}
          >
            <Block block={block} />
          </div>
        </div>
      )
    })}
  </div>
)

export default withStyles(styles, { withTheme: true })(TwoColumnLowerThird)



// WEBPACK FOOTER //
// ./src/components/Template/Layouts/TwoColumnLowerThird/index.jsx